import { useInfiniteQuery, type UseInfiniteQueryResult } from '@tanstack/react-query';
import {
  getAdminIntegrationTasks,
  type AdminIntegrationTask,
} from '../api/admin-integration-tasks';
import type { PaginatedResult } from '../../../types/common';

/**
 * Admin Task Runs hook (bagel-admin `/admin/integration-tasks`). Renamed from the earlier
 * `useIntegrationTasks` to avoid colliding with the lifted dashboard hook of the same name.
 */
export const useAdminIntegrationTasks = (
  accountId: string,
  integrationKey: string,
  pageSize = 20,
  status?: string,
): UseInfiniteQueryResult<PaginatedResult<AdminIntegrationTask>, Error> => {
  return useInfiniteQuery({
    queryKey: ['adminIntegrationTasks', accountId, integrationKey, pageSize, status],
    queryFn: ({ pageParam }) =>
      getAdminIntegrationTasks(accountId, integrationKey, pageParam, pageSize, status),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => (lastPage.hasMore ? allPages.length + 1 : undefined),
    enabled: !!accountId && !!integrationKey,
    refetchInterval: 15000,
    refetchIntervalInBackground: false,
    staleTime: 10000,
    refetchOnWindowFocus: true,
  });
};
